import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import throttle from 'lodash/throttle'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map as ImmutableMap } from 'immutable'
import { supportsPassiveEvents } from 'detect-it'
import {
  fetchStatus,
  fetchComments,
  fetchContext,
} from '../actions/statuses'
import StatusContainer from '../containers/status_container'
import StatusPlaceholder from '../components/placeholder/status_placeholder'
import { strip } from '../utils/html'
import PageTitle from './ui/util/page_title'
import StatusList from '../components/status_list'
import Text from '../components/text'
import { timelineClear } from '../store/timelines'
import ResponsiveClassesComponent from './ui/util/responsive_classes_component'
// import StatusEngagementChart from '../components/charts/status_engagement_chart'

const { isMap } = ImmutableMap

const scroll_offset = 200

class Status extends React.PureComponent {

  state = {
    lazyLoaded: false,
  }

  componentDidMount() {
    this.window = window
    this.documentElement = document.scrollingElement || document.documentElement

    const statusId = this.props.id || this.props.params.statusId
    this.props.onFetchStatus(statusId)    
    const { status, account } = this.props

    if (isMap(status)) {
      this.shouldFetchStatusParts(status)
    }

    this.props.onClearTimeline()

    this.window.addEventListener('scroll', this.handleScroll, supportsPassiveEvents ? { passive: true } : false)
  }

  componentDidUpdate(prevProps) {
    const { status, account } = this.props
    if (prevProps.status !== this.props.status && !!status) {
      this.shouldFetchStatusParts(status)
    }
    if (prevProps.statusId !== this.props.statusId && !this.props.status) {
      this.props.onFetchStatus(this.props.statusId)
    }
    if (prevProps.statusId !== this.props.statusId) {
      this.props.onClearTimeline()
    }
  }

  componentWillUnmount() {
    this.detachScrollListener()
  }

  detachScrollListener = () => {
    this.window.removeEventListener('scroll', this.handleScroll)
  }


  handleScroll = throttle(() => {
    if (this.window) {
      const { scrollTop } = this.documentElement
      
      if (scrollTop > scroll_offset && !this.state.lazyLoaded) {
        this.setState({ lazyLoaded: true })
        this.detachScrollListener()
      }
    }
  }, 150, {
    trailing: true,
  })

  get documentTitle() {
    const { account, status } = this.props
    if (isMap(account) === false || isMap(status) === false) {
      return
    }
    const username = account.get('display_name') || account.get('username')
    const content = strip(status.get('content', ''))
    const preview = content.substr(0, 50)
    const ellipsis = content.length > 50 ? '…' : ''
    return `${username} on Gab: '${preview}${ellipsis}'`
  }

  shouldFetchStatusParts = (status) => {
    if (!status) return

    const isComment = !!status.get('in_reply_to_account_id')
    const isQuote = !!status.get('quote_of_id')
    const hasComments = status.get('replies_count') > 0 || status.get('direct_replies_count') > 0
    const isOrphaned = status.get('is_reply') && !status.get('in_reply_to_id')

    if (!isOrphaned && (isComment || isQuote)) {
      this.props.onFetchContext(status.get('id'))
    } 
    if (isOrphaned || (!isComment && hasComments)) {
      this.props.onFetchComments(status.get('id'))
    }
  }

  render() {
    const { status, statusId } = this.props
    const { lazyLoaded } = this.state
  
    if (!status) {
      return <StatusPlaceholder />
    }

    const { documentTitle } = this

    return (
      <>
        {documentTitle && <PageTitle title={documentTitle} />}
        <StatusContainer {...this.props} contextType='feature' />
        {
          (lazyLoaded || status.get('direct_replies_count') === 0) &&
          <>
            <ResponsiveClassesComponent
              classNames={[_s.d, _s.pt15, _s.mt5, _s.pb15, _s.mb10].join(' ')}
              classNamesXS={[_s.d, _s.py7, _s.pl15, _s.mb5].join(' ')}
            >
              <Text size='medium' color='secondary' weight='medium'>Recent PRO gabs</Text>
            </ResponsiveClassesComponent>
            <StatusList
              scrollKey={`pro_timeline_${statusId}`}
              timelineId='pro'
              endpoint={`/api/v2/timelines/pro`}
              showInjections
              showAds
            />
          </>
        }
      </>
    )
  }

}

const mapStateToProps = (state, props) => {
  const statusId = props.id || props.params.statusId
  let status = state.getIn(['statuses', statusId])
  let account = status ? state.getIn(['accounts', status.get('account')]) : undefined

  return {
    statusId,
    status,
    account,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onClearTimeline: () => dispatch(timelineClear('related')),
  onFetchStatus: (id) => dispatch(fetchStatus(id)),
  onFetchContext: (id) => dispatch(fetchContext(id)),
  onFetchComments: (id) => {
    dispatch(fetchComments(id))
  },
})

Status.propTypes = {
  onFetchContext: PropTypes.func.isRequired,
  onFetchStatus: PropTypes.func.isRequired,
  onFetchComments: PropTypes.func.isRequired,
  params: PropTypes.object,
  status: ImmutablePropTypes.map,
  account: ImmutablePropTypes.map,
}

export default connect(mapStateToProps, mapDispatchToProps)(Status)
